import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { AttachmentViewFeatureComponent } from './attachment-view-feature.component';
import { AttachmentRoute } from './attachment.route';

@NgModule({
    declarations: [AttachmentViewFeatureComponent],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [AttachmentRoute]
        })
    ]
})
export class AttachmentModule {}
